module.exports = __webpack_public_path__ + "static/media/mobilebg2.2f86033e.jpg";